import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { CountdownTimer } from '../CountdownTimer';
import { useLaunchExpired } from '../../hooks/useLaunchCountdown';
const SEATS_TAKEN = 68;
export function Urgency() {
  const isExpired = useLaunchExpired();
  return <section className="w-full px-4 py-10 sm:px-5 sm:py-14" aria-labelledby="urgency-title" data-id="element-275" data-mp="26l5ee205754w">
      <Reveal className="mx-auto max-w-2xl rounded-3xl bg-terra-deep px-4 py-8 text-center shadow-[0_18px_44px_rgba(134,57,31,0.28)] sm:px-8 sm:py-10" data-id="element-276" data-mp="33awd6dfgvegi">
        <h2 id="urgency-title" className="mx-auto flex max-w-xl flex-col items-center justify-center gap-2 font-display text-[26px] leading-tight text-cream sm:flex-row sm:gap-2.5 sm:text-4xl" data-id="element-277" data-mp="2zb5msatur0ci">
          {isExpired ? 'La promoción de lanzamiento finalizó' : <>
              <AlarmClockIcon className="h-6 w-6 flex-shrink-0 text-gold" aria-hidden="true" data-id="element-278" data-mp="3i7dkmtkjc8xs" />
              <span data-id="element-279" data-mp="jzoss4izy2xc">Precio de lanzamiento — cierra en:</span>
            </>}
        </h2>

        {!isExpired && <div className="mt-6 flex justify-center" data-id="element-280" data-mp="oy8goah5hosc">
            <CountdownTimer data-id="element-281" data-mp="b7v9iac32e42" />
          </div>}

        <p className="mx-auto mt-6 max-w-md text-sm font-extrabold text-gold sm:text-base" data-id="element-282" data-mp="b73lbkktfint">
          {isExpired ? 'El precio volvió a su valor habitual. Podés acceder al Megapack Bolsos Crochet Pro cuando quieras.' : 'Después sube $6.000 ARS. No vuelve.'}
        </p>

        {!isExpired && <div className="mt-7 rounded-2xl bg-cocoa/35 px-4 py-5 sm:px-6" data-id="element-283" data-mp="66peg5uyaerd">
            <p className="text-center text-xs font-extrabold text-cream sm:text-sm" data-id="element-284" data-mp="3ofq7cpifw6i0">
              <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-gold align-middle" aria-hidden="true" data-id="element-285" data-mp="3sh1p68v2nnfn" />
              Cupos al precio de lanzamiento — <span className="text-gold" data-id="element-286" data-mp="1ml7h8wayrgvi">quedan pocos</span>
            </p>
            <div className="mt-3.5 h-3 w-full overflow-hidden rounded-full bg-cocoa/50" role="progressbar" aria-valuenow={SEATS_TAKEN} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-287" data-mp="1qnudd9eo3nyi">
              <div className="h-full rounded-full bg-gold" style={{
            width: `${SEATS_TAKEN}%`
          }} data-id="element-288" data-mp="2qmqlxodaoqpt" />
            </div>
            <p className="mt-2 text-right text-[11px] font-extrabold text-gold sm:text-xs" data-id="element-289" data-mp="3ibts59oqsb53">{SEATS_TAKEN}% tomados</p>
          </div>}
      </Reveal>
    </section>;
}